"use strict";
var Agent = require('./Agent');

var CrmIntegration = Agent.extend({
    validation: {}
});

module.exports = CrmIntegration;

